// Quill's semantic HTML saves every space as a non-breaking space, so a whole
// paragraph cannot wrap in an email (Wasaga, Nov 2026). The last space of a run
// breaks, so double spaces still show. A space-only paragraph stays a blank line.
const nonBreakingSpaces = /(?:&nbsp;|\u00a0)+/g;
export const withBreakableEmailSpaces = (html: string): string => html.replace(nonBreakingSpaces, (run, offset: number) => {
  const isBlankLine = /<(p|div|li)\b[^>]*>$/.test(html.slice(0, offset)) && /^<\/(p|div|li)>/.test(html.slice(offset + run.length));
  return isBlankLine ? run : `${run.replace(/\u00a0/g, "&nbsp;").slice(0, -"&nbsp;".length)} `;
});
